import {Injectable} from '@angular/core';

import {Router} from '@angular/router';

import {KngBreadcrumbItem} from '../typings/kngBreadcrumbItem';

@Injectable()
export class KngBreadcrumbsService {
  breadcrumbs: KngBreadcrumbItem[] = [];

  constructor(private router: Router) {
  }

  back() {
    if (this.breadcrumbs.length > 0) {
      this.go(this.breadcrumbs[this.breadcrumbs.length - 1]);
    }
  }

  clear() {
    this.breadcrumbs = [];
  }

  get(): KngBreadcrumbItem[] {
    return this.breadcrumbs;
  }

  go(breadcrumb: KngBreadcrumbItem) {
    // TODO
    // this.$state.go(breadcrumb.state, breadcrumb.params || {});
    console.error("TODO: this.$state.go ");
  }

  set(newBreadcrumbs: KngBreadcrumbItem[]) {
    this.breadcrumbs = newBreadcrumbs;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/services/kngBreadcrumbs.service.ts